import HeaderPortal from "components/portal/header-portal";
import { DateCell } from "@/components/date/cell";
import { EmployeeCell } from "components/cell/employee/cell";
import { NormalizeCell } from "components/cell/normalize";
import NavSlot from "@/components/navigation/tabs";
import { StatusCell } from "@/components/status/cell";
import List from "components/list";
import { TASK_FIELDS } from "../api";
import CreateItemButton from "components/buttons/create";
import { PermissionGate } from "permissions/components/gate";

export default function TasksListWrapper({
  status,
  basePath,
  storageKeyPrefix,
  baseFilters = {},
  showAssigneeColumn = false,
  renderFilters,
  teleportFilters,
}) {
  const navItems = [
    { path: basePath, label: "Open", id: "open" },
    {
      path: `${basePath}/completed`,
      label: "Completed",
      id: "completed",
    },
  ];

  const statuses =
    status === "open" ? ["open", "in_progress", "in-progress"] : ["completed"];

  const Filters = {
    status: { _in: statuses },
    ...baseFilters,
  };

  const columns = [
    {
      id: "title",
      header: "Title",
      accessorKey: "title",
    },
    ...(showAssigneeColumn
      ? [
          {
            id: "assignee",
            header: "Assignee",
            accessorKey: "assignee",
            cell: EmployeeCell,
          },
        ]
      : []),
    {
      id: "status",
      header: "Status",
      accessorKey: "status",
      cell: StatusCell,
    },
    {
      id: "type",
      header: "Type",
      accessorKey: "type",
      cell: NormalizeCell,
    },
    {
      id: "due_date",
      header: "Due Date",
      accessorKey: "due_date",
      cell: DateCell,
    },
    {
      id: "date_resolved",
      header: "Resolved Date",
      accessorKey: "date_resolved",
      cell: DateCell,
    },
  ];

  return (
    <div className="w-full" key={JSON.stringify(Filters)}>
      <HeaderPortal>
        <div className="flex items-center gap-2">
          <NavSlot navItems={navItems} />
          <PermissionGate rule="create:*" collection="tasks">
            <CreateItemButton href="/tasks/+">Task</CreateItemButton>
          </PermissionGate>
        </div>
      </HeaderPortal>

      <List
        storageKey={`${storageKeyPrefix}-${status}`}
        title="Tasks"
        endPoint="tasks"
        columns={columns}
        meta={{ fields: TASK_FIELDS }}
        filters={Filters}
        href={(item) => `${basePath}/${item.id}`}
        renderFilters={renderFilters}
        teleportFilters={teleportFilters}
      />
    </div>
  );
}
